import COUNTRIES from '../countries.translations'

import translations from './antimony.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/antimony'

export const antimony: Metal = {
  id: 22,
  slug: 'antimony',
  name: t.name,
  symbol: 'Sb',
  mines: [
    {
      name: 'Sarylakh & Sentachan (Russia, Siberia)',
      region: t.mine0Region,
      slug: 'sarylakh-sentachan',
      coordinates: [138.3, 64.2],
    },
    {
      name: 'Anzob mine (Tajikistan)',
      region: t.mine1Region,
      slug: 'anzob-mine',
      coordinates: [69.28, 39.03],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 60 },
    { name: COUNTRIES.tajikistan, percent: 17 },
    { name: COUNTRIES.russia, percent: 13 },
    { name: COUNTRIES.myanmar, percent: 4.5 },
    { name: COUNTRIES.bolivia, percent: 3.7 },
    { name: COUNTRIES.australia, percent: 2 },
    { name: COUNTRIES.turkey, percent: 1.6 },
  ],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 4, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
